// extracted by mini-css-extract-plugin
module.exports = {"th-logo":"styles_th-logo__vmzKm","th-agent-logo":"styles_th-agent-logo__LpDAZ","th-hexa":"styles_th-hexa__ALzd3"};